import React, { createContext, useContext } from "react";

declare global {
  interface Window {
    __INITIAL: any;
  }
}

type AppContextType = typeof window.__INITIAL;

const AppContext = createContext<AppContextType | null>(null);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AppContext.Provider value={window.__INITIAL}>
      {children}
    </AppContext.Provider>
  );
};

export function useApp(): AppContextType {
  const context = useContext(AppContext);
  if (!context) throw new Error("useApp must be used within an AppProvider");
  return context;
}
